module.exports = __webpack_public_path__ + "img/FBB43F_FBE993_FB552E_FCDD65-256px.2563f148.png";